import {Box, Stack, Typography} from '@mui/material';
import ArrButton from '../../../common/arr-button/ArrButton';
import {Add} from '@mui/icons-material';
import {t} from 'i18next';

interface INoJobs {
  addJobs: () => void;
}
const NoJobs = ({addJobs}: INoJobs) => {
  return (
    <Box className="no-job">
      <Stack className="no-job-text">
        <Typography
          className="typo-text subhead1_size text-headings"
          tabIndex={0}
          data-testid={`no-jobs-sub-head`}
        >
          {t('ai.review.jobList.noJobs.subHead')}
        </Typography>
        <Typography
          className="typo-text body2_size text-body-subtle"
          tabIndex={0}
          data-testid={`no-jobs-body`}
        >
          {t('ai.review.jobList.noJobs.body')}
        </Typography>
      </Stack>
      <ArrButton
        size="medium"
        endIcon={<Add />}
        onClick={addJobs}
        dataTestId="add-jobs-button"
      >
        {t('ai.review.jobList.noJobs.button')}
      </ArrButton>
    </Box>
  );
};

export default NoJobs;
